import React from 'react';
// import { useTranslate } from '../../contexts/languageContext';
import EstadisticasRankingPartidosTabla_Cabecera from './EstadisticasRankingPartidosTabla_Cabecera';
import EstadisticasRankingPartidosTabla_FilaCampo from './EstadisticasRankingPartidosTabla_FilaCampo';
import styled from 'styled-components/macro';

const EstadisticasRankingPartidosTabla = (props) => {
  // const t = useTranslate();
  return (
    <TablaEstadisticas>
      <EstadisticasRankingPartidosTabla_Cabecera data={props.data}/>
      <div className='tablaEstadisticasPartidos'>
        {props.data.data[0].lisrank.map((x)=>{
            const par = props.nomenclator.partidos[Number(x.codpar) - 1];
            const nompar = (par===undefined)?"":par.nombre;
            return( <EstadisticasRankingPartidosTabla_FilaCampo title={nompar} data={x} />)
        })}
      </div>
    </TablaEstadisticas>
  );
};

const TablaEstadisticas = styled.section`
  width:95%;
  background-color: white;
`;

export default EstadisticasRankingPartidosTabla;